module.exports = __webpack_public_path__ + "img/capac_wireless.6636d7bc.jpg";